export default __webpack_public_path__ + "static/media/stones-regular-diagram.18891122.jpg";